import { useEffect } from "react";
import { Phone } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { ChatWidget } from "@/components/site/ChatWidget";
import { Reveal } from "@/components/site/Reveal";
import { FAQ, TELEFONO, TELEFONO_HREF } from "@/data/citta";

export default function FaqPage() {
  useEffect(() => {
    document.title = "Domande frequenti — SOS Riparazioni 24";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-obsidian" data-testid="faq-page">
      <Header />
      <main className="px-5 pb-24 pt-40 md:px-8">
        <Reveal className="text-center">
          <p className="overline-label">Domande frequenti</p>
          <h1 className="mx-auto mt-4 max-w-3xl font-display text-4xl font-extrabold tracking-tight text-white text-balance sm:text-5xl">
            Tutto quello che devi sapere
          </h1>
          <p className="mx-auto mt-5 max-w-xl text-base text-slate-400">
            Le risposte alle domande che ci fanno più spesso. Non trovi la tua? Scrivici in
            chat: risponde un operatore reale.
          </p>
        </Reveal>

        <Reveal delay={0.15} className="mx-auto mt-12 max-w-3xl">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-page-accordion">
            {FAQ.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-slate-800" data-testid={`faq-page-item-${i}`}>
                <AccordionTrigger className="text-left font-display text-base font-semibold text-white hover:text-amber-400 sm:text-lg">
                  {f.domanda}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-slate-400 sm:text-base">
                  {f.risposta}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>

        <Reveal delay={0.2} className="mt-14 text-center">
          <a
            href={TELEFONO_HREF}
            data-testid="faq-page-cta"
            className="inline-flex items-center gap-2.5 rounded-full bg-amber-500 px-8 py-4 text-base font-bold text-obsidian transition-all hover:-translate-y-0.5 hover:bg-amber-400"
          >
            <Phone size={18} strokeWidth={2.5} /> Chiama ora · {TELEFONO}
          </a>
        </Reveal>
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}
